import { UseFormReturn } from "react-hook-form";
import FormSection from "../form-fields/FormSection";
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { VisaPathway } from "../VisaPathwaySelection";

interface ProfessionalQualificationsProps {
  form: UseFormReturn<any>;
  visaPathway: VisaPathway;
}

const ProfessionalQualifications = ({ form }: ProfessionalQualificationsProps) => {
  return (
    <FormSection
      title="Professional Qualifications"
      description="Tell us about your professional background and experience."
    >
      <div className="space-y-8">
        <FormField
          control={form.control}
          name="qualifications.qualifyingProfession"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Is your main profession on the list of qualifying professions? *</FormLabel>
              <FormDescription>
                <a 
                  href="https://technation.io/visa-tech-nation-visa-guide/#typical-applicants" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-primary underline"
                >
                  View qualifying professions list
                </a>
              </FormDescription>
              <FormControl>
                <RadioGroup
                  onValueChange={field.onChange}
                  defaultValue={field.value}
                  className="flex flex-col space-y-2"
                >
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="yes" />
                    </FormControl>
                    <FormLabel className="font-normal">Yes</FormLabel>
                  </FormItem>
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="not_sure" />
                    </FormControl>
                    <FormLabel className="font-normal">I am not sure</FormLabel>
                  </FormItem>
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="no" />
                    </FormControl>
                    <FormLabel className="font-normal">No</FormLabel>
                  </FormItem>
                </RadioGroup>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="qualifications.techActivityPast5Years"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Have you been involved in a professional activity (related to technology) within the last 5 years? *
              </FormLabel>
              <FormControl>
                <RadioGroup
                  onValueChange={field.onChange}
                  defaultValue={field.value}
                  className="flex flex-col space-y-2"
                >
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="yes" />
                    </FormControl>
                    <FormLabel className="font-normal">Yes</FormLabel>
                  </FormItem>
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="no" />
                    </FormControl>
                    <FormLabel className="font-normal">No</FormLabel>
                  </FormItem>
                </RadioGroup>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="qualifications.leadershipExperience"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                Have you led the growth or the marketing/business development of a digital technology company? *
              </FormLabel>
              <FormControl>
                <RadioGroup
                  onValueChange={field.onChange}
                  defaultValue={field.value}
                  className="flex flex-col space-y-2"
                >
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="yes" />
                    </FormControl>
                    <FormLabel className="font-normal">Yes</FormLabel>
                  </FormItem>
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="not_sure" />
                    </FormControl>
                    <FormLabel className="font-normal">I am not sure</FormLabel>
                  </FormItem>
                  <FormItem className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value="no" />
                    </FormControl>
                    <FormLabel className="font-normal">No</FormLabel>
                  </FormItem>
                </RadioGroup>
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        {/* Add remaining professional qualification fields */}
      </div>
    </FormSection>
  );
};

export default ProfessionalQualifications;